import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
export function Letter() {
  return <section className="py-24 px-6 bg-soft-gradient relative" data-id="element-216">
      {/* Subtle paper texture overlay could go here if needed, keeping it clean for now */}

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-[780px] mx-auto bg-white rounded-3xl shadow-luxury-card border border-[#E8E8F0] p-8 md:p-[60px] flex flex-col items-center" data-id="element-217">
        <Logo className="w-[60px] h-[60px] mb-6" data-id="element-218" />
        <div className="w-[80px] h-[2px] bg-champagne-gold mb-8" data-id="element-219"></div>

        <span className="text-champagne-gold font-montserrat font-semibold text-sm tracking-[0.2em] uppercase mb-4 text-center" data-id="element-220">
          Una Carta Para Ti
        </span>

        <h2 className="font-playfair font-bold text-deep-blue text-[38px] text-center mb-10" data-id="element-221">
          De Mujer a Mujer
        </h2>

        <div className="flex flex-col items-center mb-12" data-id="element-222">
          <img src="https://cdn.magicpatterns.com/uploads/vT5yPvfj7fQtygAWKwqbyy/ChatGPT_Image_3_may_2026,_19_23_49_(1).png" alt="Lorena Pérez" className="w-[100px] h-[100px] rounded-full border-[3px] border-champagne-gold shadow-md object-cover object-top mb-3" data-id="element-223" />
          <span className="font-montserrat text-gray-text text-sm" data-id="element-224">
            Lorena Pérez, 54 años
          </span>
        </div>

        <div className="font-cormorant text-soft-black text-[20px] leading-[2.2] max-w-[640px] w-full space-y-6" data-id="element-225">
          <p data-id="element-226">Mi bella,</p>

          <p data-id="element-227">
            Si llegaste hasta aquí es porque algo en ti resonó. Quizás estás en
            medio de tu proceso. Quizás ya lo completaste. Quizás apenas estás
            empezando.
          </p>

          <p data-id="element-228">
            En cualquiera de esos momentos, tienes algo que vale oro:
            <br data-id="element-229" />
            Tu historia.
          </p>

          <p data-id="element-230">
            Yo sé lo que es buscar respuestas y no encontrarlas. Yo sé lo que es
            mirar el espejo y no reconocerse. Lo viví.
          </p>

          <p data-id="element-231">
            Y después de 25 años acompañando a mujeres como tú y como yo,
            aprendí algo que nunca olvidaré:
          </p>

          <p data-id="element-232">
            No necesitas tenerlo todo resuelto. No necesitas resultados
            perfectos. No necesitas ser la versión más transformada de ti misma.
          </p>

          <p data-id="element-233">Solo necesitas ser honesta. Solo necesitas atreverte.</p>

          <p data-id="element-234">
            Porque hay una mujer ahí afuera que está exactamente donde tú
            estabas, sintiendo exactamente lo que tú sentías, y lo único que
            necesita es saber que alguien como ella lo logró.
          </p>

          <p data-id="element-235">Esa alguien eres tú.</p>

          <p data-id="element-236">
            A mis 54 años, con 25 años de este camino, te digo con certeza
            absoluta:
          </p>

          <p className="font-semibold text-deep-blue text-2xl text-center my-8" data-id="element-237">
            Después de los 40, el cuerpo no se apaga.
            <br data-id="element-238" />
            Se renueva.
          </p>
        </div>

        <div className="w-full max-w-[640px] flex flex-col items-end mt-8" data-id="element-239">
          <span className="font-cormorant italic text-deep-blue text-[32px] mb-2" data-id="element-240">
            Lorena Pérez
          </span>
          <span className="font-montserrat font-light text-gray-text text-[13px] text-right" data-id="element-241">
            Fundadora RenuevaTE_90 | Saludable sin ser Esclavo | 25 años con
            Herbalife
          </span>
        </div>

        <div className="w-[60px] h-[2px] bg-champagne-gold mt-12" data-id="element-242"></div>
      </motion.div>
    </section>;
}